export enum TransactionalOperationEnum {
    enabled = "ENABLED",
    disabled = "DISABLED"
} 